/* eslint-disable react/no-children-prop */
import React from 'react';
import { Container, CssBaseline } from '@mui/material';

import useStyles from '../../../assets/styles/pages/Fidelity';

import Favorites from '../../../components/Favorites';
import Header from '../../../components/Header';
import FooterMenuMain from '../../../components/FooterMenuMain';

const FavoritesPage: React.FC = () => {
  const classeStyle = useStyles();

  return (
    <Container maxWidth={false} className={classeStyle.container}>
      <Header children="User" />
      <CssBaseline />
      <Favorites />
      <FooterMenuMain children="fidelity" />
    </Container>
  );
};

export default FavoritesPage;
